// extracted by mini-css-extract-plugin
module.exports = {"row--first":"_25d45facb5--row--first--FvJgp","row--second":"_25d45facb5--row--second--jU7Kl"};